class QuickAdd extends HTMLElement {
  connectedCallback() {
    this.els = {
      dialog: this.querySelector('[data-quick-add-el="dialog"]'),
    }

    this.setupEventListeners()
  }

  setupEventListeners() {
    document.addEventListener('click', this.handleSubmit.bind(this))
    document.addEventListener('click', this.handleNotify.bind(this))
    document.addEventListener('change', this.handleVariantChange.bind(this))
  }

  handleVariantChange(event) {
    const fieldset = event.target.closest('[data-quick-add-el="fieldset"]')

    if (!fieldset) return

    this.updateVariantRadios(event.target)
    this.setButtonstate(event.target)
    this.setStockMessage(event.target)
    this.setSelectedVariant(event.target.value)
  }

  updateVariantRadios(target) {
    document.querySelectorAll('[data-quick-add-el="option"]').forEach((option) => {
      option.checked = option === target
    })
  }

  setButtonstate(target) {
    const submitButton = document.querySelector('[data-quick-add-el="submit"]')
    const notifyButton = document.querySelector('[data-quick-add-el="notify"]')

    if (!submitButton && !notifyButton) return

    const isOutOfStock = target.dataset.stock === '0'

    submitButton.setAttribute('aria-hidden', isOutOfStock)
    submitButton.disabled = isOutOfStock

    notifyButton.setAttribute('aria-hidden', !isOutOfStock)
    notifyButton.disabled = !isOutOfStock
  }

  setStockMessage(target) {
    const stockText = document.querySelector('[data-quick-add-el="stock-text"]')

    if (!stockText) return

    stockText.textContent = target.dataset.stockMessage || ''
  }

  setSelectedVariant(variantId) {
    const variantInput = document.querySelector('[data-quick-add-el="variant-input"]')
    const notifyButton = document.querySelector('[data-quick-add-el="notify"]')

    if (!variantInput && !notifyButton) return

    variantInput.value = variantId
    notifyButton.dataset.variantId = variantId
  }

  handleSubmit(event) {
    const submitButton = event.target.closest('[data-quick-add-el="submit"]')

    if (!submitButton) return

    event.preventDefault()

    submitButton.disabled = true
    submitButton.textContent = 'Adding...'

    window.Moonbase.ajaxCart.handleAddToCartClick(event)

    setTimeout(() => {
      this.closeDrawer()
    }, 2000)
  }

  handleNotify(event) {
    const notifyButton = event.target.closest('[data-quick-add-el="notify"]')

    if (!notifyButton) return

    this.closeDrawer()
  }

  closeDrawer() {
    this.isOpen = false

    document.body.style.overflow = ''

    this.els.dialog.close()
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd)
}